/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddChargeAction from './AddChargeAction/index'
import ApplyAdjustmentAction from './ApplyAdjustmentAction/index'
import ApplyFixAdjustmentAction from './ApplyFixAdjustmentAction/index'
import ChangeDatesAction from './ChangeDatesAction/index'
import CreatePaymentPlanAction from './CreatePaymentPlanAction/index'
import CreateStatementAction from './CreateStatementAction/index'
import DeleteInvoiceAction from './DeleteInvoiceAction/index'
import PostPaymentAction from './PostPaymentAction/index'
import React from 'react'
import TransferDebtAction from './TransferDebtAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/ActionsCell/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-10-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={14}
 color={dtColorsNeutral500}
 weight="medium"
 text="Invoice actions"
/>
<PostPaymentAction
  viewPath={`${viewPath}/PostPaymentAction`}
/>
<AddChargeAction
  viewPath={`${viewPath}/AddChargeAction`}
/>
<ApplyAdjustmentAction
  viewPath={`${viewPath}/ApplyAdjustmentAction`}
/>
<ChangeDatesAction
  viewPath={`${viewPath}/ChangeDatesAction`}
/>
<CreatePaymentPlanAction
  viewPath={`${viewPath}/CreatePaymentPlanAction`}
/>
<TransferDebtAction
  viewPath={`${viewPath}/TransferDebtAction`}
/>
<CreateStatementAction
  viewPath={`${viewPath}/CreateStatementAction`}
/>
<ApplyFixAdjustmentAction
  viewPath={`${viewPath}/ApplyFixAdjustmentAction`}
/>
<DeleteInvoiceAction
  viewPath={`${viewPath}/DeleteInvoiceAction`}
/>
</div>
{children}
</React.Fragment>)
}